module.exports = __webpack_public_path__ + "static/media/mps_gain_f.f9c4b4da.webp";